import { render, staticRenderFns } from "./products-slider.vue?vue&type=template&id=44bd3a20&"
import script from "./products-slider.vue?vue&type=script&lang=js&"
export * from "./products-slider.vue?vue&type=script&lang=js&"
import style0 from "./products-slider.vue?vue&type=style&index=0&id=44bd3a20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports